import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
const steps = ['Explore the 6 volumes.', 'Review the maps.', 'Use the checklists.', 'Test the tools.'];
export function Guarantee() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-151" data-mp="24lndix3yp622">
      <div className="mx-auto max-w-3xl" data-id="element-152" data-mp="29e6ornf6fp3p">
        <div className="rounded-3xl border-2 border-teal-500/40 bg-white p-6 text-center sm:p-10" data-id="element-153" data-mp="29f825yjo0nol">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-teal-50 text-teal-600" data-id="element-154" data-mp="2ecrs3vpq6owd">
            <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-155" data-mp="2jdxlzwv4gi7h" />
          </span>
          <h2 className="mt-5 font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-156" data-mp="2o9338idkx8p8">
            7-day money-back guarantee
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-navy-700/85 sm:text-base" data-id="element-157" data-mp="ty7ung2e9tmg">
            Try the GLP-1 Decision Map™ completely risk-free.
          </p>

          <ul className="mx-auto mt-6 grid max-w-md grid-cols-2 gap-2.5" data-id="element-158" data-mp="3sl6inq1nkzrn">
            {steps.map(step => <li key={step} className="rounded-xl bg-cream px-3 py-2.5 text-left text-[13px] font-semibold leading-snug text-navy-700" data-id="element-159" data-mp="3nu6kkhgssbnk">
                {step}
              </li>)}
          </ul>

          <p className="mt-6 text-[15px] leading-relaxed text-navy-700/85 sm:text-base" data-id="element-160" data-mp="3dufqggw5fyo0">
            If within 7 days you feel the system doesn't provide the value you expected, simply
            request a refund. No complicated forms. No hassle. No questions asked.
          </p>
        </div>

        <SectionCta label="Try it risk-free for 7 days" data-id="element-161" data-mp="5ew3u0pzhehx" />
      </div>
    </section>;
}